/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

/* default */
:host {
  font-size: 1rem;
  font-weight: 600;
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
  border-color: #007CC1;
  border-color: var(--davinci-color-primary, #007CC1);
  color: #FFF;
  color: var(--davinci-color-text-on-primary, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-primary, #FFF);
  contain: content;
  border-width: 1px;
  border-style: solid;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  outline: 0;
  text-align: center;
  padding: 0 calc(15rem/14);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: calc(46rem/14 - (2 * 1px));
  min-width: calc(46rem/14 - (2 * 1px));
  -webkit-box-flex: 1;
          flex: 1 1 auto;
}
:host > .flexbox {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: center;
          justify-content: center;
  align-content: flex-start;
  -webkit-box-align: center;
          align-items: center;
  height: 100%;
  width: 100%;
}
:host > .flexbox > davinci-icon {
  -webkit-box-flex: 0;
          flex: 0 0 auto;
  width: calc(24rem/14);
  height: calc(24rem/14);
}
:host > .flexbox > davinci-icon + .slotwrapper {
  margin-left: calc(8rem/14);
}
:host > .flexbox > davinci-icon + .slotwrapper ::slotted(*):empty {
  display: none;
}
:host > .flexbox > .slotwrapper {
  -webkit-box-flex: 0;
          flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host > .flexbox > .slotwrapper ::slotted(*) {
  vertical-align: middle;
  color: #FFF;
  color: var(--davinci-color-text-on-primary, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-primary, #FFF);
}
:host > .flexbox > .slotwrapper.empty {
  display: none;
}

:host(:empty),
:host(.empty) {
  max-width: calc(2.875rem - (2 * 1px));
  padding: 0;
}
:host(:empty) .slotwrapper,
:host(.empty) .slotwrapper {
  display: none;
}

/* STATE: Default */
:host([type=primary-alt]) {
  background-color: #323C43;
  background-color: var(--davinci-color-secondary, #323C43);
  border-color: #323C43;
  border-color: var(--davinci-color-secondary, #323C43);
  color: #FFF;
  color: var(--davinci-color-text-on-secondary, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary, #FFF);
}
:host([type=primary-alt]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-secondary, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary, #FFF);
}

:host([type=accent]) {
  background-color: #F39200;
  background-color: var(--davinci-color-accent, #F39200);
  border-color: #F39200;
  border-color: var(--davinci-color-accent, #F39200);
  color: #FFF;
  color: var(--davinci-color-text-on-accent, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-accent, #FFF);
}
:host([type=accent]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-accent, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-accent, #FFF);
}

:host([type=outline]) {
  background-color: transparent;
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  border-color: #007CC1;
  border-color: var(--davinci-color-primary, #007CC1);
}
:host([type=outline]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}

:host([type=outline-alt]) {
  background-color: transparent;
  color: #323C43;
  color: var(--davinci-color-secondary, #323C43);
  fill: #323C43;
  fill: var(--davinci-color-secondary, #323C43);
  border-color: #323C43;
  border-color: var(--davinci-color-secondary, #323C43);
}
:host([type=outline-alt]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #323C43;
  color: var(--davinci-color-secondary, #323C43);
  fill: #323C43;
  fill: var(--davinci-color-secondary, #323C43);
}

:host([type=bare]) {
  background-color: transparent;
  border-color: transparent;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host([type=bare]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}

:host([type=bare-alt]) {
  background-color: transparent;
  border-color: transparent;
  fill: #323C43;
  fill: var(--davinci-color-secondary, #323C43);
  color: #323C43;
  color: var(--davinci-color-secondary, #323C43);
}
:host([type=bare-alt]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #323C43;
  color: var(--davinci-color-secondary, #323C43);
  fill: #323C43;
  fill: var(--davinci-color-secondary, #323C43);
}

/* STATE: Hover/Focus */
:host(.entered) {
  background-color: #009DF4;
  background-color: var(--davinci-color-primary-light, #009DF4);
  border-color: #009DF4;
  border-color: var(--davinci-color-primary-light, #009DF4);
}

:host([type=primary-alt].entered) {
  background-color: #505F6B;
  background-color: var(--davinci-color-secondary-light, #505F6B);
  border-color: #505F6B;
  border-color: var(--davinci-color-secondary-light, #505F6B);
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-light, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFF);
}
:host([type=primary-alt].entered) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-light, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFF);
}

:host([type=accent].entered) {
  background-color: #FFA927;
  background-color: var(--davinci-color-accent-light, #FFA927);
  border-color: #FFA927;
  border-color: var(--davinci-color-accent-light, #FFA927);
  color: #FFF;
  color: var(--davinci-color-text-on-accent-light, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-accent-light, #FFF);
}
:host([type=accent].entered) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-accent-light, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-accent-light, #FFF);
}

:host([type=outline].entered) {
  background-color: #009DF4;
  background-color: var(--davinci-color-primary-light, #009DF4);
  border-color: #009DF4;
  border-color: var(--davinci-color-primary-light, #009DF4);
  color: #FFF;
  color: var(--davinci-color-text-on-primary-light, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-primary-light, #FFF);
}
:host([type=outline].entered) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-primary-light, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-primary-light, #FFF);
}

:host([type=outline-alt].entered) {
  background-color: #505F6B;
  background-color: var(--davinci-color-secondary-light, #505F6B);
  border-color: #505F6B;
  border-color: var(--davinci-color-secondary-light, #505F6B);
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-light, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFF);
}
:host([type=outline-alt].entered) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-light, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFF);
}

:host([type=bare].entered) {
  background-color: transparent;
  border-color: transparent;
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}
:host([type=bare].entered) > .flexbox > .slotwrapper ::slotted(*) {
  color: var(--davinci-primary-light, );
  fill: var(--davinci-primary-light, );
}

:host([type=bare-alt].entered) {
  background-color: transparent;
  border-color: transparent;
  color: #505F6B;
  color: var(--davinci-color-secondary-light, #505F6B);
  fill: #505F6B;
  fill: var(--davinci-color-secondary-light, #505F6B);
}
:host([type=bare-alt].entered) > .flexbox > .slotwrapper ::slotted(*) {
  color: #505F6B;
  color: var(--davinci-color-secondary-light, #505F6B);
  fill: #505F6B;
  fill: var(--davinci-color-secondary-light, #505F6B);
}

/* STATE: Active */
:host(:active),
:host([selected]) {
  background-color: #005B8E;
  background-color: var(--davinci-color-primary-dark, #005B8E);
  border-color: #005B8E;
  border-color: var(--davinci-color-primary-dark, #005B8E);
}

:host([type=primary-alt]:active),
:host([type=primary-alt][selected]) {
  background-color: #1C2226;
  background-color: var(--davinci-color-secondary-dark, #1C2226);
  border-color: #1C2226;
  border-color: var(--davinci-color-secondary-dark, #1C2226);
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-dark, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-dark, #FFF);
}
:host([type=primary-alt]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=primary-alt][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-dark, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-dark, #FFF);
}

:host([type=accent]:active),
:host([type=accent][selected]) {
  background-color: #E36A00;
  background-color: var(--davinci-color-accent-dark, #E36A00);
  border-color: #E36A00;
  border-color: var(--davinci-color-accent-dark, #E36A00);
  color: #FFF;
  color: var(--davinci-color-text-on-accent-dark, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-accent-dark, #FFF);
}
:host([type=accent]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=accent][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-accent-dark, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-accent-dark, #FFF);
}

:host([type=outline]:active),
:host([type=outline][selected]) {
  background-color: #005B8E;
  background-color: var(--davinci-color-primary-dark, #005B8E);
  border-color: #005B8E;
  border-color: var(--davinci-color-primary-dark, #005B8E);
  color: #FFF;
  color: var(--davinci-color-text-on-primary-dark, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-primary-dark, #FFF);
}
:host([type=outline]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=outline][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-primary-dark, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-primary-dark, #FFF);
}

:host([type=outline-alt]:active),
:host([type=outline-alt][selected]) {
  background-color: #1C2226;
  background-color: var(--davinci-color-secondary-dark, #1C2226);
  border-color: #1C2226;
  border-color: var(--davinci-color-secondary-dark, #1C2226);
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-dark, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-dark, #FFF);
}
:host([type=outline-alt]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=outline-alt][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-dark, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-dark, #FFF);
}

:host([type=bare]:active),
:host([type=bare][selected]) {
  background-color: transparent;
  border-color: transparent;
  color: #005B8E;
  color: var(--davinci-color-primary-dark, #005B8E);
  fill: #005B8E;
  fill: var(--davinci-color-primary-dark, #005B8E);
}
:host([type=bare]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=bare][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: var(--davinci-primary-dark, );
  fill: var(--davinci-primary-dark, );
}

:host([type=bare-alt]:active),
:host([type=bare-alt][selected]) {
  background-color: transparent;
  border-color: transparent;
  color: #1C2226;
  color: var(--davinci-color-secondary-dark, #1C2226);
  fill: #1C2226;
  fill: var(--davinci-color-secondary-dark, #1C2226);
}
:host([type=bare-alt]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=bare-alt][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #1C2226;
  color: var(--davinci-color-secondary-dark, #1C2226);
  fill: #1C2226;
  fill: var(--davinci-color-secondary-dark, #1C2226);
}

/* STATE: Disabled */
:host([disabled]) {
  pointer-events: none;
  cursor: default;
}

:host([disabled]) {
  background-color: #D2D9DD;
  background-color: var(--davinci-color-outline-disabled, #D2D9DD);
  border-color: #D2D9DD;
  border-color: var(--davinci-color-outline-disabled, #D2D9DD);
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
  fill: #8999A4;
  fill: var(--davinci-color-text-disabled, #8999A4);
}
:host([disabled]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
  fill: #8999A4;
  fill: var(--davinci-color-text-disabled, #8999A4);
}

:host([type=outline][disabled]),
:host([type=outline-alt][disabled]) {
  background-color: transparent;
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
  fill: #8999A4;
  fill: var(--davinci-color-text-disabled, #8999A4);
  border-color: #D2D9DD;
  border-color: var(--davinci-color-outline-disabled, #D2D9DD);
}
:host([type=outline][disabled]) > .flexbox > .slotwrapper ::slotted(*),
:host([type=outline-alt][disabled]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
  fill: #8999A4;
  fill: var(--davinci-color-text-disabled, #8999A4);
}

:host([type=bare][disabled]),
:host([type=bare-alt][disabled]) {
  background-color: transparent;
  border-color: transparent;
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
  fill: #8999A4;
  fill: var(--davinci-color-text-disabled, #8999A4);
}
:host([type=bare][disabled]) > .flexbox > .slotwrapper ::slotted(*),
:host([type=bare-alt][disabled]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
  fill: #8999A4;
  fill: var(--davinci-color-text-disabled, #8999A4);
}`;
export { style };
//# sourceMappingURL=Button.style.js.map